import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@/store';
import Cookies from 'js-cookie';
import { withPayloadEncryption } from '@/utils/encryptedBaseQuery';
import { isSigningError } from '@/utils/requestSign';

const baseUrl = import.meta.env.VITE_API_BASE_URL || '/api';

const baseQuery = withPayloadEncryption(
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.accessToken;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  { baseUrl }
);

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401 && !isSigningError(result.error)) {
    console.warn('Unauthorized! Logging out user...');
    Cookies.remove('authToken');
    setTimeout(() => {
      if (window.location.pathname === '/login') return;
      window.location.href = '/login';
    }, 2000);
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ['User', 'Auth', 'FeatureFlags', 'Competitions', 'Events', 'PendingMarkets', 'RollbackMarkets'],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {
  util: { getRunningQueriesThunk },
} = apiSlice;

export default apiSlice;